import { Component } from "@angular/core";

@Component({
  template: `<div class="text-center p-7">
    <div
      class="bg-warning text-white rounded-full inline-flex justify-center items-center w-[48px] h-[48px]"
    >
      <patternlib-icon iconName="forbidden" size="24px" />
    </div>
    <h3 class="text-h3 font-head my-5">
      {{ "access_denied_title" | translate }}
    </h3>
    <p class="text-copy font-text text-gray-800">
      {{ "access_denied_text" | translate }}
    </p>
  </div>`,
})
export class AccessDeniedPage {}
